import api from "./apiBase";

function getFavorites(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`/favorites?${query}`);
}

function addFavorite(id) {
  return api.post("/favorites/" + id);
}

export {
  getFavorites,
  addFavorite,
}
